import { useEffect, useState } from 'react'

export interface TuplDaySummary {
  dead_trips: number
  lost_trips: number
  expected_km: number
  live_km: number
}

const EMPTY: TuplDaySummary = { dead_trips: 0, lost_trips: 0, expected_km: 0, live_km: 0 }

/** Dead/lost trip counts and expected/live km for today, pushed live over SSE rather
 * than polled -- see serving/tupl.py's day_summary_events/_ensure_km_ticker, which only
 * publishes when the numbers actually change (a 5s-cadence background recompute, not a
 * per-telemetry-point push). EventSource reconnects on its own after a drop, and the
 * server always sends the current snapshot as the first frame of a fresh connection, so
 * a reconnect self-heals without any separate bootstrap fetch. */
export function useTuplDaySummary(): TuplDaySummary {
  const [summary, setSummary] = useState<TuplDaySummary>(EMPTY)
  useEffect(() => {
    const es = new EventSource('/api/tupl/events/day-summary')
    es.onmessage = (ev: MessageEvent<string>) => {
      try {
        setSummary(JSON.parse(ev.data) as TuplDaySummary)
      } catch {
        /* a malformed frame must not kill the stream */
      }
    }
    return () => es.close()
  }, [])
  return summary
}
